(function ($, Drupal) {
  Drupal.behaviors.reloadPage = {
    attach: function attach(context) {
      $('.js-reload-page', context).on('click', (e) => {
        e.preventDefault();
        location.reload();
      });
    },
  };
}(jQuery, Drupal));
